import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-background flex flex-col min-h-screen" }
const _hoisted_2 = { class: "border-b rounded-3xl" }
const _hoisted_3 = { class: "container mx-auto px-4 py-4 flex items-center relative" }
const _hoisted_4 = { class: "flex-grow container mx-auto px-4 py-8" }
const _hoisted_5 = ["innerHTML"]

import { useRouter } from 'vue-router'
import { ArrowLeft } from 'lucide-vue-next'
import { Button } from '@/components/ui/button'
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card'
import { ScrollArea } from '@/components/ui/scroll-area'
import { useTenant } from '@/composables/useTenant';


export default /*@__PURE__*/_defineComponent({
  __name: 'TermsOfUseView',
  setup(__props) {

const router = useRouter()
const { tenant } = useTenant()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(Button), {
          variant: "ghost",
          size: "sm",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).back())),
          class: "flex items-center gap-2 text-muted-foreground hover:text-foreground transition-colors"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(ArrowLeft), { class: "w-4 h-4" })
          ]),
          _: 1
        }),
        _cache[1] || (_cache[1] = _createElementVNode("h1", { class: "text-[1.1rem] font-bold text-foreground absolute left-1/2 -translate-x-1/2 pointer-events-none" }, " Termos de Uso ", -1))
      ])
    ]),
    _createElementVNode("main", _hoisted_4, [
      _createVNode(_unref(Card), { class: "max-w-3xl mx-auto" }, {
        default: _withCtx(() => [
          _createVNode(_unref(CardHeader), null, {
            default: _withCtx(() => [
              _createVNode(_unref(CardTitle), { class: "text-[1.0rem] font-semibold" }, {
                default: _withCtx(() => _cache[2] || (_cache[2] = [
                  _createTextVNode("Por favor, leia atentamente nossos termos")
                ])),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(CardContent), null, {
            default: _withCtx(() => [
              _createVNode(_unref(ScrollArea), { class: "h-[60vh] pr-4" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: "space-y-4 text-muted-foreground",
                    innerHTML: _unref(tenant).termsOfUse
                  }, null, 8, _hoisted_5)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
}
}

})